<script setup lang="ts">
import Button from 'primevue/button'

const { t } = useNuxtApp().$i18n
// Use cookie for business ID since we're always on POS routes now
const business_id = useCookie('buuid').value
const shiftStore = useShiftStore()
const businessStore = useBusinessStore()
const {
  shiftStatus,
  shift,
} = storeToRefs(shiftStore)

if (business_id) {
  businessStore.setBusinessId(business_id)
  await shiftStore.fetchEmployees()
}

// Per-device view preference. Defaults to v1 (zero behaviour change on first
// use); set to 'v2' when the user opts in from the banner/button. "Ver Turno"
// then honours whichever they last chose.
const viewPref = useCookie<'v1' | 'v2'>('shift_view_pref', { default: () => 'v1' })

function viewShift(): void {
  const base = viewPref.value === 'v2' ? '/store/pos/v2/shift' : '/store/pos/shift'
  navigateTo(`${base}?shiftId=${shiftStore.shiftId}`)
}
</script>

<template>
  <div class="flex">
    <Button
      v-if="shiftStatus === 'closed'"
      :label="t('Start shift')"
      class="p-1 text-sm"
      icon="pi pi-clock"
      size="small"
      @click="shiftStore.openShiftDialog"
    />
    <Button
      v-if="shiftStatus === 'open'"
      :label="t('Close shift')"
      class="p-1 ml-1 text-sm"
      size="small"
      icon="pi pi-times"
      @click="shift && shiftStore.closeShiftDialog(shift)"
    />
    <Button
      v-if="shiftStatus === 'open'"
      :label="t('View shift')"
      class="p-1 ml-1 text-sm"
      icon="pi pi-eye"
      size="small"
      @click="viewShift"
    />
  </div>
</template>
